import React, { Component } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  YAxis,
  LabelList,
} from "recharts";

const style_ = {
  height: "50px",
  width: "auto",
  padding: "10px",
  backgroundColor: "white",
};
class CustomizedAxisTick extends Component {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dx={-6} textAnchor="end" fill="#666" fontSize={11}>
          {payload.value}
        </text>
      </g>
    );
  }
}

const CustomizedMostPopularLabel = (props) => {
  const { x, y, value } = props;
  if (value !== 0) {
    return (
      <g>
        <text
          x={value > 0 ? x + props.width+5 : x+5}
          // x={ x}
          y={value > 20 ? y + 17 : y + 10}
          fill="#000"
          fontSize={13}
          position="right"
        >
          {props.value.toFixed(2)}%
        </text>
      </g>
    );
  } else {
    return (
      <g>
        <text x={x} y={y + 10} fill="#000" position="right">
          {props.value.toFixed(2)}%
        </text>
      </g>
    );
  }
};

class SkuGraph extends Component {
  constructor() {
    super();
    this.state = {
      labelData: [],
    };
  }

  changeData = (values) => {
    let myData = [];
    values.forEach((item) => {
      myData.push({
        Brand:
          item.MasterSku != null && item.MasterSku.length > 14
            ? // ? item.MasterSku.slice(0, 13) + "..."
              item.MasterSku
            : item.MasterSku,
        Accuracy: item.Accuracy ? item.Accuracy : item.Accuracy,
        name: item.MasterSku,
      });
    });
    // this.setState({ labelData: myData });
    return myData;
  };

  renderLabelList(e, data) {
    // console.log('LABEL',data)
    return data.map((elm, ind) => {
      return elm.Accuracy.toFixed(2);
    });
  }

  CustomTooltip = ({ active, payload, label }) => {
    if (active) {
      return (
        <div className="custom-tooltip" style={style_}>
          <p className="label">{`${
            payload[0].payload.name
          } : ${payload[0].payload.Accuracy.toFixed(2)}`}</p>
        </div>
      );
    }

    return null;
  };

  renderLegend = (props) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          margin: "0 auto",
          marginTop: "20px",
          alignItems: "center",
          width: "300px",
          height: "20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#4d79a8",
            height: "10px",
            width: "10px",
            margin: "5px 10px 0px 0px",
          }}
        ></div>
        <p style={{ alignSelf: "center" }}>SKU Forecast Accuracy</p>
      </div>
    );
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <BarChart
          layout="vertical"
          width={700}
          height={800}
          data={
            this.props.data.length
              ? this.changeData(this.props.data)
              : this.props.data
          }
          margin={{
            top: 5,
            right: 30,
            left: 140,
            bottom: 5,
          }}
        >

          <XAxis type="number" hide padding={{right:40}} />
          <YAxis
            type="category"
            dataKey="Brand"
            width={130}
            tick={<CustomizedAxisTick />}
          />
          <Tooltip content={this.CustomTooltip} />
          <Bar dataKey="Accuracy"  fill={this.props.type === 'top'?'#3575b6':'#a9bcd0'} barSize={20}>
            <LabelList
              content={<CustomizedMostPopularLabel />}
              dataKey="Accuracy"
              position="right"
              // angle="45"
            />
          </Bar>
        </BarChart>
      </div>
    );
  }
}
export default SkuGraph;